<template>
  <lego-modal-extend-v2
    class="modal-montarget-detail-popup"
    ref="modal"
    :title="$t('title.monTargetDetail')"
    :sub-title="targetData.productName"
    @closed="close"
  >
    <div class="mon-target-wrapper">
      <div class="select-formbox-wrap">
        <div class="selectbox-col">
          <c-scroll :classStyle="'height-scroll'">
            <mon-target-info-section
              v-if="detailList.length"
              :detailFilter="detailList"
              :target-data="targetData"
              :product-type-code="params.productTypeCode"
              :chip-items="chipItem"
              :customFields="customFieldValue"
            ></mon-target-info-section>
          </c-scroll>
        </div>
        <div class="formbox-col">
          <div class="lego-tab-container">
            <div class="action-container">
              <ScpmReloadDatePicker
                v-show="tabIdx !== 4"
                ref="reloadPicker"
                isPerformance
                isMonitoringPerformance
                :isApp="isApp"
                :defaultValue="defaultInquiryPeriod"
                :isDashboard="isDashboard"
                :refreshPlay="isRefreshPlay"
                :startDate="params.startDt"
                :dateTime="dateTime"
                @refresh="refresh"
                @save="refresh"
              />
              <!-- refreshPlay 옵션은 기본값으로 reload기능 활성화 여부 -->
            </div>
            <lego-tab-box
              class="tabbox-container"
              :default-idx="this.defaultTab"
              @tab-change="tabChange"
            >
              <lego-tab-label :idx="1">{{ $t('tab.performance') }}</lego-tab-label>
              <lego-tab-label :idx="2" :disabled="!this.logTabActive"
                >{{ $t('tab.log') }}
              </lego-tab-label>
              <lego-tab-label :idx="3" :disabled="productTypeCode === 'CDN'">{{
                $t('tab.event')
              }}</lego-tab-label>
              <lego-tab-label v-if="isShowAgentTab" :idx="4">{{ $t('tab.agent') }}</lego-tab-label>
            </lego-tab-box>
            <!-- 성능탭 -->
            <MonTargetPerformance
              ref="MonTargetPerformance"
              v-if="tabIdx === 1"
              :params="modalParam"
              :scrollHeight="scrollHeight"
              :searchDate="searchDateParam"
              @open-event-add-setting="openAddSettingPopup"
              @cdn-order="cdnOrdering"
              @toggle-sub-modal="toggleSubModal"
              @on-zoom="onZoomChart"
            />
            <!-- 로그탭 -->
            <MonTargetLog
              v-if="tabIdx === 2"
              :params="modalParam"
              :scrollHeight="'320px'"
              :searchDate="searchDateParam"
              @toggle-sub-modal="toggleSubModal"
            />
            <!-- 이벤트탭  -->
            <MonTargetEvent
              v-if="tabIdx === 3"
              :params="modalParam"
              :initailEventId="params.eventId"
              :scrollHeight="scrollHeight"
              :searchDate="searchDateParam"
              @open-event-add-setting="openAddSettingPopup"
              @close="close"
            />
            <MontargetAgent
              v-if="tabIdx === 4 && isShowAgentTab"
              :params="modalParam"
              :managedYn="monTargetData.managedYn"
              :productInfoAttrs="monTargetData.productInfoAttrs"
            />
            <EventAddModal
              v-if="isEventAddShow && selectedTargetAddSetting.metric"
              :product-type-code="productTypeCode"
              :selected-target="selectedTargetAddSetting"
              isPerformance
              @close="togglePopup"
              @confirm="togglePopup"
            />
          </div>
        </div>
      </div>
    </div>
  </lego-modal-extend-v2>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import i18nMixin from '@/mixins/i18n.mixin.js';
import monTargetMixin from './monTarget.mixin.js';
import MonTargetPerformance from '@/containers/popup/MonTargetPerformance.vue';
import MonTargetLog from '@/containers/popup/MonTargetLog.vue';
import MonTargetEvent from '@/containers/popup/MonTargetEvent.vue';
import MontargetAgent from '@/containers/popup/MontargetAgent.vue';
import cScroll from '@/components/cmp/cScroll/cScroll.vue';
import ScpmReloadDatePicker from '@/components/scpm/components/scpmReloadDatePicker/scpmReloadDatePicker';
import { PRODUCT_TYPES } from '@/containers/utils/constant.js';
import { scpmUtil as $util } from '../../utils/scpmUtil';
import EventAddModal from '../event/eventSettings/EventAddModal.vue';
import MonTargetInfoSection from './MonTargetInfoSection.vue';
import { useCheckAuth } from '@/composables/useCheckAuthorization.js';

const { checkAuth } = useCheckAuth();
export default {
  name: 'MonTargetDetailPopup',
  emits: ['close'],
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    activeTab: {
      type: Number,
      default: 1
    },
    defaultValue: {
      type: String,
      default: '30m'
    },
    isDashboard: { type: Boolean, default: false },
    refreshPlay: { type: Boolean, default: false },
    dateTime: { type: Object, default: null },
    isApp: { type: Boolean, default: false }
  },
  mixins: [i18nMixin, monTargetMixin],
  components: {
    MonTargetInfoSection,
    EventAddModal,
    MonTargetPerformance,
    MonTargetLog,
    MonTargetEvent,
    MontargetAgent,
    cScroll,
    ScpmReloadDatePicker
  },
  data() {
    return {
      selectedTargetAddSetting: {
        metric: null,
        targets: []
      },
      isEventAddShow: false,
      isOpendedAccordion: false,
      modalParam: {},
      monTargetData: {},
      targetData: {},
      searchDateParam: {},
      searchDate: {},
      productId: '',
      productTypeCode: '',
      productResourceId: '',
      productName: '',
      productType: '',
      productInfo: '',
      productDisk: '',
      productStorageInfo: '',
      productProtocol: '',
      productNodeCount: '',
      productLbLayerType: '',
      productClusterName: '',
      serviceDomain: '',
      dstTgwName: '',
      podCount: '',
      hpcNodeCount: '',
      dataOpsClusterName: '',
      vpcIsIGW: 'N', // vpc private
      vpcPeeringObjectItems: [],
      metricName: [],
      metricVal: [],
      metrics: [],
      localTrue: true,
      localFalse: false,
      tabIdx: 0,
      startDate: '',
      endDate: '',
      defaultTab: this.activeTab,
      logTabActive: false,
      monSchema: {},
      detailInfo: [],
      detailFilter: {},
      isTagShow: false,
      chipItem: [],
      isTagAuth: true,
      resourceName: '',
      logging: '',
      endpointType: '',
      endpoint: '',
      productNodeType: '',
      fromEventMap: false, // 최초 대시보드 이벤트맵에서 호출할 때
      expandStatus: false,
      PRODUCT_TYPES: PRODUCT_TYPES,
      iconProductType: '',
      isRefreshPlay: true,
      isShowAgentTab: false,
      defaultTimeInquiry: null,
      isCheckEvent: false,
      vpcId: '',
      detailList: [],
      sharedInterval: {
        interval: '1m'
      }
    };
  },
  computed: {
    $util() {
      return $util;
    },
    // 페이지 제목
    getPageTitle() {
      let result = this.$t('title.monTargetDetail');
      return result;
    },
    detailInfoLabelStyle() {
      return {
        color: '#787c84'
      };
    },
    scrollHeight() {
      return '622px';
    },
    isVpc() {
      return this.productTypeCode === 'VPC';
    },
    isCdn() {
      return this.productTypeCode === 'CDN';
    },
    defaultInquiryPeriod() {
      return this.isCdn ? '7d' : '30m';
    },
    isInternetGateway() {
      return this.productTypeCode === 'IGW';
    },
    displayClusterName() {
      return this.productTypeCode === 'MULTINODE-GPU'
        ? this.monSchema.gpuClusterName
        : this.monSchema.clusterName;
    },
    isHPCCluster() {
      return this.productTypeCode === 'HPCCluster';
    },
    isDataOpsDataFlow() {
      return this.productTypeCode === 'DataOps' || this.productTypeCode === 'DataFlow';
    },
    getClusterName() {
      return this.isDataOpsDataFlow ? this.dataOpsClusterName : this.productClusterName;
    },
    isBlockStorage() {
      return ['VM', 'Bare Metal Server', 'VM-GPU', 'MULTINODE-GPU'].includes(this.productTypeCode);
    },
    productStateValue() {
      return this.$util.runningIcon(this.targetData.productState, this.targetData.productState);
    },
    getLabelServerType() {
      if (this.isDataOpsDataFlow) {
        return this.monSchema.dataType;
      } else if (this.productTypeCode === 'File Storage') {
        return this.monSchema.diskType;
      }

      return this.monSchema.serverType;
    },
    getProductState() {
      return [
        PRODUCT_TYPES.DIRECT_CONNECT,
        PRODUCT_TYPES.OBJECT_STORAGE,
        PRODUCT_TYPES.BARE_MENTAL_SERVER,
        PRODUCT_TYPES.INTERNET_GATEWAY
      ].includes(this.productTypeCode);
    },
    customFieldValue() {
      return {
        dataOpsClusterName: this.dataOpsClusterName,
        productClusterName: this.productClusterName,
        productDisk: this.productDisk,
        productStorageInfo: this.productStorageInfo,
        productProtocol: this.productProtocol,
        serviceDomain: this.serviceDomain,
        vpcId: this.vpcId,
        vpcIsIGW: this.vpcIsIGW,
        hpcNodeCount: this.hpcNodeCount,
        podCount: this.podCount
      };
    }
  },
  provide() {
    return {
      onInsightChartZoom: () => {
        this.onZoomChart();
      },
      sharedInterval: this.sharedInterval
    };
  },
  created() {
    if (this.params.logId != null) {
      this.defaultTab = 2;
    } else if (this.params.eventId != null) {
      this.defaultTab = 3;
      this.fromEventMap = !(
        this.params.searchDate === undefined || this.params.searchDate.refreshInterval === undefined
      );
    }
    if (this.isDashboard) {
      this.isRefreshPlay = this.refreshPlay;
    }

    if (this.params.startDt) {
      this.isRefreshPlay = false;
    }

    this.productId = this.params.productId ?? this.params.productSq;
    this.productTypeCode = this.params.productTypeCode;
    this.iconProductType = this.$store.state.iconProductType;

    this.getProductInfoFilter();
    this.setLabel();
  },
  mounted() {
    this.initStateComponent();
  },
  methods: {
    async getCollectionInterval() {
      this.sharedInterval.interval = await this.$http.product.getCollectionInterval(
        this.productTypeCode
      );
    },
    onZoomChart() {
      this.$nextTick(() => {
        if (this.$refs.reloadPicker) {
          this.$refs.reloadPicker.onPause(() => {
            this.$toast.open(this.$t('label.descDisableInqueryTime'));
          });
        }
      });
    },
    async checkShowAgentTab() {
      const params = {
        productSq: this.monTargetData.productId,
        productTypeCode: this.monTargetData.productTypeCode
      };
      await this.$http.log.getProductAgentLog(params).then((res) => {
        this.isShowAgentTab = res.paas;
      });
    },
    setNoDataText(metric) {
      if (metric?.metricName.includes('Packets') && this.productLbLayerType.includes('L7')) {
        return this.monSchema.packetNoData;
      }
      return this.monSchema.noData;
    },
    async initStateComponent() {
      this.$refs['modal'].open();
      // this.$refs.accordion.isExpend = false;
      await this.getCollectionInterval();
      // 대시보드 이벤트맵에서 진입할 때 확인
      this.initCheckFromEventMap();

      await this.getProductSubTypes();
      this.getDetail();
      this.getProductCondition();
      this.getVpcPeeringData();
    },
    initCheckFromEventMap() {
      let initTimeValues;

      if (this.fromEventMap) {
        initTimeValues = this.params.searchDate; // type : object
      } else if (this.isDashboard) {
        initTimeValues = this.defaultValue;
      } else if (this.dateTime && this.isApp) {
        initTimeValues = this.dateTime.tab1value;
      } else {
        initTimeValues = this.defaultInquiryPeriod; // Global CDN 상품일때 초기시간 세팅 (type : string)
      }

      // this.$refs.reloadPicker.$refs.popup.setDate(initTimeValues, this.setSearchDate() );
      this.$refs.reloadPicker.setDate(initTimeValues, this.setSearchDate());
    },

    getEllipsisState(e) {
      this.isEllipsis = e.target.offsetWidth > 350;
    },

    getProductInfoFilter() {
      this.detailFilter = _.cloneDeep(this.infoFilter);
    },

    setLabel() {
      this.monSchema = _.cloneDeep(this.labelField);
    },
    async toggleAccordion() {
      this.isOpendedAccordion = !this.isOpendedAccordion;

      if (!this.isOpendedAccordion) {
        return;
      }

      // 상세정보 열릴 때 데이터 동기화
      this.handleAccorion();
      this.refresh();
    },

    async getProductCondition() {
      let params = {
        productTypeCode: this.productTypeCode,
        conditionType: 'metric'
      };
      if (this.productTypeCode === 'KAFKA') params.productSq = this.params.productId;
      await this.$http.product
        .getProductConditions(params.productTypeCode, params.conditionType, params.productSq, true)
        .then((data) => {
          if (this.$util.isNotEmpty(data) && data.detailList) {
            this.detailList = data.detailList;
            this.detailInfo = data.detailList.map((detail) => detail.apifieldname);
          }
        })
        .catch((err) => {
          if (err && err.code == 'AccessDenied') {
            this.$alert(err);
          }
        });
    },

    // 모니터링대상 정보 조회
    async getDetail() {
      const listDataCheckAuth = [
        {
          productResourceId: this.productId,
          productName: this.params.productName
        }
      ];
      const payload = {
        productTypeCode: this.productTypeCode,
        params: {
          productId: this.productId
        },
        listDataCheckAuth
      };

      await this.$store.dispatch('authStore/checkProductDetail', payload).then((res) => {
        if (res.type !== this.$const.AuthorizationResult.ALLOW) return;
        const data = res.responseData;

        if (this.$util.isNotEmpty(data)) {
          this.monTargetData = data;
          this.targetData = data;

          this.tagParams = {
            productResourceId: data.productResourceId,
            productTypeCode: data.productTypeCode
          };

          if (this.$util.isNotEmpty(data.productInfoAttrs)) {
            this.getInfoDetails(data, data.productInfoAttrs);
          }

          if (this.$util.isNotEmpty(data.metrics)) {
            this.getInfoMetrics(data.metrics);
          }

          this.getTags();
          this.handleAccorion();
          this.checkShowAgentTab();
        }
      });
    },

    mappingAttributesAndAction() {
      return {
        diskSize: {
          attribute: 'productDisk'
        },
        storageInfo: {
          attribute: 'productStorageInfo',
          action: (attrValue) => {
            return attrValue === '' || attrValue === null ? this.monSchema.noData : attrValue;
          }
        },
        clusterName: {
          attribute: 'productClusterName'
        },
        serviceDomain: {
          attribute: 'serviceDomain'
        },
        connectedVPC: {
          attribute: 'targetData',
          action: (attrValue) => {
            let connectedVpcItems = attrValue.replace('[', '').replace(']', '').split(',');
            return { ...this.targetData, connectedVpcItems };
          }
        },
        dstTgwName: {
          attribute: 'dstTgwName'
        },
        drUseYn: {
          attribute: 'targetData',
          subAttribute: 'drUseYn',
          action: (attrValue) => this.isUsePresent(attrValue)
        },
        accessControlYn: {
          attribute: 'targetData',
          subAttribute: 'accessControlYn',
          action: (attrValue) => this.isUsePresent(attrValue)
        },
        logging: {
          attribute: 'targetData',
          subAttribute: 'logging',
          action: (attrValue) => (attrValue === 'Y' ? this.monSchema.useY : this.monSchema.useN)
        },
        autoscaling: {
          attribute: 'targetData',
          subAttribute: 'autoscaling',
          action: (attrValue) => (attrValue === 'N' ? 'Unused' : 'Used')
        }
      };
    },

    // 모니터링대상 상세정보
    getInfoDetails(infos, attrs) {
      let layerType;
      let protocolType;
      const attributesAndAction = this.mappingAttributesAndAction();

      for (let i = 0; i < attrs.length; i++) {
        let attrItem = attrs[i];
        let { attrName, attrValue } = attrItem;
        this.targetData[attrName] = attrValue;

        if (attrName === 'lbName' && this.productTypeCode === PRODUCT_TYPES.LB)
          this.targetData.productName = attrValue;

        if (attrItem.attrName === 'maxNodeCount' && this.isHPCCluster)
          this.targetData.maxNodeCount = '';

        if (['drUseYn', 'accessControlYn'].includes(attrName))
          this.targetData[attrName] = this.isUsePresent(attrValue);

        if (attrName === 'layerType') layerType = attrValue;
        if (attrName === 'protocol') protocolType = attrValue;

        if (!['lbName', 'maxNodeCount', 'protocol', 'layerType'].includes(attrName)) {
          const handler = attributesAndAction[attrName];

          if (handler) {
            const val = Object.hasOwn(handler, 'action') ? handler.action(attrValue) : attrValue;

            if (Object.hasOwn(handler, 'subAttribute')) {
              this[handler.attribute][handler.subAttribute] = val;
            } else {
              this[handler.attribute] = val;
            }
          }
        }

        if (this.isHPCCluster) {
          this.detailFilter.nodeCount = false;
          this.detailFilter.hpcNodeCount = true;
        }

        if (this.productTypeCode === 'Kubernetes') {
          if (
            attrItem.attrName === 'maxNodeCount' &&
            ((attrItem.attrValue === 'null' ? null : attrItem.attrValue) || 0) <= 0
          ) {
            if (attrItem.attrValue.length) {
              this.productNodeCount = 0;
            } else {
              this.productNodeCount = this.monSchema.noData;
            }
          }
        }

        if (this.isVpc && attrItem.attrName === 'isIGW') {
          this.vpcIsIGW = attrValue;
        }

        if (this.isInternetGateway && attrItem.attrName === 'vpcId') {
          this.vpcId = attrValue;
        }

        if (
          this.productTypeCode === 'KAFKA' &&
          attrItem.attrName !== 'diskSize' &&
          attrItem.attrValue.length === 0
        ) {
          this.detailFilter.diskSize = true;
          this.productDisk = this.monSchema.noData;
        }

        if (this.productTypeCode === 'File Storage(New)') {
          if (attrItem.attrName !== 'type' && attrItem.attrValue.length === 0) {
            this.detailFilter.type = true;
            this.productInfo = this.monSchema.noData;
          }
          if (attrItem.attrName !== 'protocol' && attrItem.attrValue.length === 0) {
            this.detailFilter.protocol = true;
            this.productProtocol = this.monSchema.noData;
          }
        }
      }

      if (typeof layerType != 'undefined' && typeof protocolType != 'undefined') {
        this.productLbLayerType = layerType + '  ' + protocolType;
      }

      if (this.isHPCCluster) {
        this.hpcNodeCount = infos.nodeCount.slice(0, -2);
      }

      if (this.productTypeCode === 'TGW' && this.dstTgwName === '') {
        if (
          _.isObject(attrs) === false ||
          infos.dstTgwName === null ||
          (typeof infos.dstTgwName === 'undefined' &&
            Object.keys(infos).includes('dstTgwName') === false)
        ) {
          this.dstTgwName = this.monSchema.noData;
        }
      }

      if (this.isCdn && this.serviceDomain === '') {
        if (infos.serviceDomain === null) {
          this.serviceDomain = this.monSchema.noData;
        } else if (infos.serviceDomain.length > 0) {
          this.serviceDomain = infos.serviceDomain;
        }
      }

      if (this.isDataOpsDataFlow) {
        this.dataOpsClusterName = infos.clusterName;
        this.podCount = infos.podCount === null ? this.monSchema.noData : String(infos.podCount);
      }
    },

    // 모니터링대상 메트릭정보
    getInfoMetrics(metrics) {
      // 대표성능항목 상위 4개까지만 표시
      let metricsLegnth = metrics.length;
      if (metricsLegnth >= 4) metricsLegnth = 4;

      let i = 0;
      this.metricName = [];
      this.metrics = [];

      metrics.forEach((metric) => {
        if (i < metricsLegnth && this.detailInfo.includes(metric.metricName)) {
          const metricItem = this.formatMetric(metric);
          this.metricName.push(metricItem.metricName);
          this.metrics.push(metricItem);
          i++;
        }
      });
    },
    formatMetric(metric) {
      let { metricUnit, value } = metric;
      let unitType = this.$util.getUnitType(metricUnit);
      let metricName = this.isVpc
        ? metric.metricTitle.replace(/ (Private)| (Public)| (Internet)/gi, '')
        : metric.metricTitle;
      let metricAttr = null;

      if (metric.value === null)
        return {
          metricName,
          metricVal: null,
          metricUnit: null,
          metricValText: null
        };

      if (unitType == 'FILE') {
        metricAttr = this.$util.formatFileUnit(value, metricUnit, 2);
      } else if (unitType == 'TIME') {
        metricAttr = this.$util.formatTimes(value, metricUnit, 2);
      } else {
        let tempFormat = this.$util.formatNumber(value, 2);
        metricAttr = { ...tempFormat, unit: tempFormat.unit + ' ' + metric.metricUnit };
      }

      return {
        metricName,
        metricVal: metricAttr.value,
        metricUnit: metricAttr.unit,
        metricValText: this.setDecimalFormat(metricAttr.value) + ' ' + metricAttr.unit
      };
    },

    // 아코디언 UI
    handleAccorion() {
      if (this.isOpendedAccordion) {
        this.tabChange(this.tabIdx);
      } else {
        this.tabChange(this.defaultTab);
      }
    },

    async getVpcPeeringData() {
      if (this.isVpc) {
        let params = { metricKeyList: [], productIdList: [] };
        params.metricKeyList.push('vpc.statics.peering.rx.total_bytes');
        params.productIdList.push(this.productId);

        await this.$http.product
          .getProductObjects(params, this.productTypeCode, true)
          .then((data) => {
            this.vpcPeeringObjectItems = this.$util.replaceArr(data, {
              objectName: 'value',
              objectDisplayName: 'text'
            });
          })
          .catch((err) => {
            if (err && err.code == 'AccessDenied') {
              this.$alert(err);
            }
          });
      }
    },

    setDecimalFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    async getProductSubTypes() {
      await this.$http.agent.getProductSubTypes().then((data) => {
        if (
          data.filter((p) => p.productTypeCode === this.params.productTypeCode).length > 0 ||
          this.productTypeCode === 'Kubernetes' ||
          this.productTypeCode === 'Cloud Functions'
        ) {
          this.logTabActive = true;
        }
      });
    },

    getTags() {
      this.apiGetTags(this.monTargetData.productResourceId, this.productTypeCode).then((data) => {
        this.chipItem = this.$util.getListTag(data);
      });
    },

    showDetailTab() {
      this.passModalParam(this.tabIdx);
    },
    close() {
      this.$emit('close', true);
    },
    onClickComfirm() {
      this.close();
    },
    tabChange(val) {
      if (val === 2 && !this.logTabActive) return;
      this.tabIdx = val;
      this.isThumbnail = true;

      this.showDetailTab();
    },
    passModalParam() {
      this.isThumbnail = this.isCdn ? false : true;
      this.modalParam = {
        agentInfos: this.params.agentInfos,
        projectId: this.params.projectId,
        productId: this.monTargetData.productId,
        productResourceId: this.monTargetData.productResourceId,
        monKey: this.monTargetData.monKey,
        productTypeCode: this.monTargetData.productTypeCode,
        objectTypeCode: this.params.objectTypeCode,
        productName: this.targetData.productName,
        startDate: this.searchDate.queryStartDt,
        endDate: this.searchDate.queryEndDt,
        isInActive: this.params.eventState == 'INACTIVE' ? true : false,
        eventId: this.params.eventId,
        check: true
      };
      if (this.tabIdx === 1 || this.tabIdx === 2) {
        this.modalParam.type = this.isThumbnail;
      }
      if (this.tabIdx === 2) {
        this.modalParam.productName = this.targetData.productName;
      }
    },
    setSearchDate() {
      window.setTimeout(() => {
        this.searchDate = this.$refs.reloadPicker.getCurrentDate();
        if (this.params.startDt) {
          this.searchDate.queryStartDt = moment(this.params.startDt)
            .subtract(30, 'minutes')
            .toISOString();
          this.searchDate.queryEndDt = moment(this.params.startDt).toISOString();
        }
        this.searchDateParam = this.searchDate;

        if (this.searchDate.queryStartDt === undefined) {
          this.searchDate.queryStartDt = this.params.searchDate.queryStartDt;
          this.searchDateParam.queryStartDt = this.params.searchDate.queryStartDt;
        }
        if (this.searchDate.queryEndDt === undefined) {
          this.searchDate.queryEndDt = this.params.searchDate.queryEndDt;
          this.searchDateParam.queryEndDt = this.params.searchDate.queryEndDt;
        }

        if (this.searchDate.refreshInterval === undefined) this.searchDate.refreshInterval = '1';

        if (this.fromEventMap) {
          this.searchDateParam.queryStartDt = this.params.searchDate.queryStartDt;
          this.searchDateParam.queryEndDt = this.params.searchDate.queryEndDt;
          this.searchDate.queryStartDt = this.params.searchDate.queryStartDt;
          this.searchDate.queryEndDt = this.params.searchDate.queryEndDt;
          this.searchDate.refreshInterval = this.params.searchDate.refreshInterval;
        }
      }, 100);
    },

    refresh(isSave = false) {
      if (this.isCdn && this.checkTimeSearch()) {
        return;
      }
      this.params.startDt = '';
      this.fromEventMap = false;
      this.setSearchDate();
      this.passModalParam();

      if (this.isOpendedAccordion) {
        this.getDetail();
        if (this.isVpc) this.getVpcPeeringData();
      }
    },
    resetDataAddSetting() {
      this.selectedTargetAddSetting = {
        metric: null,
        targets: []
      };
    },

    checkTimeSearch() {
      const datePicker = this.$refs.reloadPicker.getCurrentDate() || {};
      const { queryStartDt, queryEndDt } = datePicker;
      if (!queryStartDt || !queryEndDt) return;
      const currentDate = moment().valueOf();
      const startDate = moment(queryStartDt).valueOf();
      const timeStampOfOneDay = 24 * 60 * 60 * 1000;
      if (startDate > currentDate - timeStampOfOneDay) {
        this.$alert(this.$t('label.cdnGuide'));
        this.$refs.reloadPicker.setRefreshInterval(this.searchDate.refreshInterval || '1');
        if (this.searchDate.dateType === 1) {
          this.$refs.reloadPicker.datePickerRef.$refs.datepicker.setDate(
            this.searchDate.tab1value,
            () => {},
            true
          );
        } else {
          this.$refs.reloadPicker.datePickerRef.$refs.datepicker.setDate(
            this.searchDate,
            () => {},
            true
          );
        }
        return true;
      }
      return false;
    },

    // cdn일때 성능차트 순서 = metric항목
    cdnOrdering(data) {
      if (this.metricName !== data) {
        this.metricName = data;
      }
    },

    // Object Storage 유형 일때 사용/미사용 표기
    isUsePresent(value) {
      return value === 'Y' ? this.monSchema.useY : this.monSchema.useN;
    },

    toggleExpand(payload) {
      this.expandStatus = payload;
    },
    openAddSettingPopup(item, metric) {
      this.resetDataAddSetting();
      const productResourceIds = item && [item.productResourceId];
      const productTypeCode = item && item.productTypeCode;
      const listDataCheckAuth = item && [
        {
          productResourceId: item.productResourceId,
          productName: item.productName
        }
      ];
      const callback = (data) => {
        if (data.type === this.$const.AuthorizationResult.ALLOW) {
          this.selectedTargetAddSetting.metric = metric;
          this.selectedTargetAddSetting.targets.push({
            ...item,
            productSq: item.productSq ?? item.productId,
            label: item.productName,
            value: item.productName
          });
          this.isEventAddShow = true;
        }
      };
      const errorCallback = (err) => {
        this.$alert(err);
      };
      checkAuth(
        {
          productTypeCode,
          productResourceIds,
          listDataCheckAuth,
          actionName: this.$const.AuthorizationAction.MONITOR_VIEW
        },
        callback,
        errorCallback
      );
    },
    togglePopup() {
      this.resetDataAddSetting();
      this.isEventAddShow = !this.isEventAddShow;
    },
    toggleSubModal(isSubModalOpen) {
      this.isRefreshPlay = !isSubModalOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
$layoutSelectboxColMargin: 24px;
$layoutSelectboxColHeight: 752px;
$layoutSelectboxMetric: 0px;

.modal-montarget-detail-popup :deep .modal__body {
  overflow: hidden !important;
}

.monitoring-lego-modal__body__noscr :deep .lego-modal__body__noscr {
  padding: 20px 20px 20px 20px;
}

.monitoring-lego-madal_container :deep .lego-modal__container {
  padding: 0;
  max-height: 100%;
}

.monitoring-lego-modal__body :deep .lego-modal__body {
  padding: 30px;
  height: 750px;
  max-height: 100%;
}

.monitoring-info-wrap {
  // padding: 12px 0px;
  box-sizing: border-box;

  .monitoring-inner-wrap {
    :deep .simplebar-track.simplebar-vertical {
      right: 6px;
    }

    :deep .simplebar-content {
      height: 148px;
    }
  }
}

.monitoring-info-section {
  display: flex;
  flex-direction: column;
  gap: 36px;
  width: 100%;

  .left-col {
    width: 50%;
  }

  .right-col {
    width: 50%;
  }
}

.monitoring-target-section {
  padding: 0 20px 0 0px;
}

.monitoring-metric-section {
  border-top: 1px solid #e4e5e7;
  padding: 12px;
}

.lego-tab-container {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .action-container {
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    height: 54px;
  }
}

:deep .accordion-list-item.monitoring-inner-wrap {
  margin-top: 0;
  width: 240px !important;

  & .accordion-list-item__main {
    height: 16px !important;
    padding: 0;
    font-size: 14px;
    background-color: #fff;
  }

  & .accordion-list-item__expand {
    border: none !important;

    .monitoring-info-wrap {
      border-bottom: 0;
    }
  }
}

:deep .c-scroll-height-detail {
  padding: 10px 20px;
}

:deep .lego-text-field.connectedvpc {
  .lego-text-field__input {
    height: 26px !important;
  }
}

:deep .simplebar-mask,
:deep .simplebar-content {
  overflow: visible !important;
}

:deep {
  .lego-modal__container {
    border: none;
  }

  .mon-target-wrapper {
    .select-formbox-wrap {
      display: flex;
      align-content: center;
      justify-content: center;

      .selectbox-col {
        width: 278px;
        height: calc($layoutSelectboxColHeight - 2 * $layoutSelectboxColMargin);
        border-right: 1px solid rgb(227, 229, 232);
        margin: $layoutSelectboxColMargin 0;

        .height-scroll {
          margin: 0px 0 12px 0;
          height: calc(
            $layoutSelectboxColHeight - 2 * $layoutSelectboxColMargin - $layoutSelectboxMetric
          );
        }
      }

      & .formbox-col {
        width: calc(100% - 278px);
        padding: 0 0 12px 24px;
      }
    }
  }

  .tabbox-container .lego-tab__label {
    height: 54px;
  }

  .text-item-wrap {
    // position: relative;
    font-family: $lego__font-family !important;

    .text-label-wrap {
      width: auto;
      height: auto;
      display: flex;

      .text-label {
        display: flex;
        width: 90%;
        font-family: $lego__font-family;
        font-size: 14px;
        line-height: 16px;
        color: #2f3237;
        font-weight: 600;
        height: auto;
      }
    }

    .text-field-wrap {
      width: 240px;
    }
  }

  .lego-tab__content-wrapper {
    border-top: 1px solid #e3e5e8;
  }

  .lego-tab__label-underline {
    border-bottom: 0;

    &::after {
      bottom: 0;
      border-bottom-color: transparent;
    }
  }

  .lego-tab__label-underline--active:after {
    border-bottom: 2px solid #364fc7 !important;
  }

  .range-wrap {
    right: 0;
  }

  .lego-chip__container {
    border: none !important;
  }

  .dev_no-data {
    max-width: 100%;
  }
}
</style>
